import type { VoucherActivationResolutionResponse } from '@/api/gen/_model/voucherActivationResolutionResponse';
import type { TrialVoucherActivationTrackingContext } from '@/shared/features/trial-voucher/trialVoucherContext';

import { setPaymentResolutionContext } from './paymentResolutionContext';

export const handleVoucherActivationResolution = async ({
  resolution,
  voucherHashId,
  trialTrackingContext,
  navigate,
}: {
  resolution: VoucherActivationResolutionResponse;
  voucherHashId: string;
  trialTrackingContext?: TrialVoucherActivationTrackingContext;
  navigate: (href: string) => Promise<unknown>;
}) => {
  if (resolution.state === 'COMPLETED') return 'completed' as const;

  if (resolution.state === 'PROCESSING' && resolution.paymentOrderId) {
    setPaymentResolutionContext(resolution.paymentOrderId, {
      kind: 'voucher',
      voucherHashId,
      trialTrackingContext,
    });
    await navigate(
      `/checkout/processing?flow=async&orderId=${encodeURIComponent(
        resolution.paymentOrderId,
      )}`,
    );
    return 'processing' as const;
  }

  throw new Error(
    `Unexpected voucher activation resolution: ${resolution.state}`,
  );
};
